import Image from 'next/image'

export default function ProductCard(props: { title: string; content: string; price: string; image: string }) {
  return (
    <div className="card bg-[#0f0f0f] border border-[#808183] text-white rounded-2xl">
      <div className="m-2">
        <Image src={props.image} alt={props.title} width="0" height="0" sizes="100vw" className="w-full h-auto rounded-xl" />
      </div>

      <div className="m-2 items-start">
        <h2 className="text-[5vw]">{props.title}</h2>
        <p className="text-[3vw]">{props.content}</p>
      </div>
      <div className="card-actions justify-end">
        <p className="mx-[3vw] mb-[2vw] text-[5vw]">{props.price} تومان</p>
      </div>
    </div>
  )
}
